import {Form, Modal, Input, Tag, Button, Popconfirm, message} from "antd";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import TableTransfer from "./TableTransfer";
import {getLocaleLang} from "../../../utils/helpers";
import {useFormik} from "formik";
import stores from "../../../store/stores";

const UserGroupModal = ({
    visibility,
    modalTitle,
    detail,
    allPermissionPolicies,
    onCancel,
    setRecallUserGroup
}) => {
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [sendLoading, setSendLoading] = useState(false);
    const {t, i18n} = useTranslation(["userAuthorization"]);
    const onOk = async () => {
        handleSubmit();
    };
    const originTargetKeys = detail?.permissionPolicies.map(item => item.key);

    // Açıklamalar uzun olabildiği için sütun genişliği sabit tutulup metin alt satıra sarılır;
    // tek satırda bırakılırsa Table, Transfer'in flex item'ını genişliğine göre büyütüp
    // modal sınırını taşırıyordu (bkz. TableTransfer.js tableLayout="fixed").
    const renderWrappedDescription = description => (
        <p style={{margin: 0}}>{description[getLocaleLang(i18n)]}</p>
    );

    const leftTableColumns = [
        {
            dataIndex: "name",
            title: t("common.permissionPolicy", {ns: "userAuthorization"}),
            width: 160,
            render: name => <p>{name[getLocaleLang(i18n)]}</p>
        },
        {
            dataIndex: "tags",
            title: t("components.permissionPolicyList.fields.tags", {
                ns: "userAuthorization"
            }),
            width: 160,
            render: tags => tags.map(tag => <Tag>{tag}</Tag>)
        },
        {
            dataIndex: "description",
            title: t("components.permissionPolicyList.fields.description", {
                ns: "userAuthorization"
            }),
            width: 220,
            render: renderWrappedDescription
        }
    ];
    const rightTableColumns = [
        {
            dataIndex: "name",
            title: t("common.permissionPolicy", {ns: "userAuthorization"}),
            width: 160,
            render: name => <p>{name[getLocaleLang(i18n)]}</p>
        },
        {
            dataIndex: "tags",
            title: t("components.permissionPolicyList.fields.tags", {
                ns: "userAuthorization"
            }),
            width: 160,
            render: tags => tags.map(tag => <Tag>{tag}</Tag>)
        },
        {
            dataIndex: "description",
            title: t("components.permissionPolicyList.fields.description", {
                ns: "userAuthorization"
            }),
            width: 220,
            render: renderWrappedDescription
        }
    ];

    const isDetail =
        modalTitle === t("modals.userGroupDetailModal.label", {ns: "userAuthorization"});

    const formik = useFormik({
        initialValues: {
            nameTr: detail?.name.tr,
            nameEn: detail?.name.en,
            key: detail?.key,
            permissions: originTargetKeys
        },

        enableReinitialize: true,
        onSubmit: async () => {
            setSendLoading(true);

            if (!isDetail) {
                const {nameTr, nameEn, key, permissions} = values;

                if (!nameTr || !nameEn || !key || !permissions || !permissions.length) {
                    setSendLoading(false);
                    message.error(t("common.pleaseFillAllFields", {ns: "userAuthorization"}));
                    return;
                }
                await stores.authorizationStore.createUserGroup({
                    key: values.key,
                    name: {
                        tr: values.nameTr,
                        en: values.nameEn
                    },
                    permissionPolicies: values.permissions
                });
            } else {
                await stores.authorizationStore.updateUserGroup({
                    userGroupId: detail._id,
                    key: values.key,
                    name: {
                        tr: values.nameTr,
                        en: values.nameEn
                    },
                    permissionPolicies: values.permissions
                });
            }
            setRecallUserGroup(prev => !prev);
            onCancel();
            setSendLoading(false);
        }
    });
    const {values, setFieldValue, handleSubmit} = formik;

    const deleteUserGroup = async () => {
        setDeleteLoading(true);
        await stores.authorizationStore.deleteUserGroup({
            userGroupId: detail._id
        });

        setRecallUserGroup(prev => !prev);
        onCancel();
        setDeleteLoading(false);
    };

    const renderFooter = () => {
        return (
            <>
                <Popconfirm
                    title={t("confirms.userGroup.delete.title", {ns: "userAuthorization"})}
                    description={t("confirms.userGroup.delete.description", {
                        ns: "userAuthorization"
                    })}
                    onConfirm={deleteUserGroup}
                    okText={t("modal.yesButton", {ns: "common"})}
                    cancelText={t("modal.noButton", {ns: "common"})}
                >
                    <Button
                        style={{
                            float: "left"
                        }}
                        type="primary"
                        danger
                        loading={deleteLoading}
                        disabled={deleteLoading}
                    >
                        {t("actions.delete", {ns: "common"})}
                    </Button>
                </Popconfirm>
                <Button onClick={onCancel}>{t("modal.cancelButton", {ns: "common"})}</Button>
                <Button type="primary" disabled={sendLoading} loading={sendLoading} onClick={onOk}>
                    {isDetail
                        ? t("actions.update", {ns: "common"})
                        : t("modal.saveButton", {ns: "common"})}
                </Button>
            </>
        );
    };
    return (
        <Modal
            centered
            width={1200}
            title={modalTitle}
            visible={visibility}
            onCancel={onCancel}
            footer={renderFooter()}
        >
            <Form layout={"vertical"} style={{maxWidth: 600}}>
                <Form.Item label={t("common.userGroup", {ns: "userAuthorization"}) + " tr"}>
                    <Input
                        value={values?.nameTr}
                        onChange={e => {
                            setFieldValue("nameTr", e.target.value);
                        }}
                    />
                </Form.Item>
                <Form.Item label={t("common.userGroup", {ns: "userAuthorization"}) + " en"}>
                    <Input
                        value={values?.nameEn}
                        onChange={e => {
                            setFieldValue("nameEn", e.target.value);
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label={t("components.permissionPolicyList.fields.key", {
                        ns: "userAuthorization"
                    })}
                >
                    <Input
                        value={values?.key}
                        onChange={e => {
                            setFieldValue("key", e.target.value);
                        }}
                    />
                </Form.Item>
            </Form>
            <TableTransfer
                dataSource={allPermissionPolicies}
                targetKeys={values?.permissions}
                onChange={nextTargetKeys => setFieldValue("permissions", nextTargetKeys)}
                filterOption={(inputValue, item) =>
                    item.title.indexOf(inputValue) !== -1 || item.tag.indexOf(inputValue) !== -1
                }
                leftColumns={leftTableColumns}
                rightColumns={rightTableColumns}
            />
        </Modal>
    );
};

export default UserGroupModal;
